import move from './move'
import unique from './unique'
import chunk from './chunk'

export default { move, unique, chunk }
